import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProfileService } from '../../../../services/profile.service';
import { NbGlobalPosition, NbGlobalPhysicalPosition, NbToastrService, NbComponentStatus } from '@nebular/theme';

@Component({
  selector: 'protocol-change-request-dialog',
  templateUrl: './protocol-change-request-dialog.component.html',
  styleUrls: ['./protocol-change-request-dialog.component.scss']
})
export class ProtocolChangeRequestDialogComponent implements OnInit {

  requestBody: any;
  requestError: Boolean = false;
  loading: boolean = false;
  destroyByClick = true;
  duration = 5000;
  hasIcon = true;
  position: NbGlobalPosition = NbGlobalPhysicalPosition.TOP_RIGHT;
  preventDuplicates = false;
  statusSuccess: 'success';
  statusFailure: 'warning';
  isDemo: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ProtocolChangeRequestDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private profileService: ProfileService,
    private toastrService: NbToastrService
  ) { }

  ngOnInit() {
  }

  sendChangeRequest() {
    if (this.requestBody == null || this.requestBody == '') {
      this.requestError = true;
      return false;
    }

    const data = {
      'body': this.requestBody,
      'customerKey': sessionStorage.getItem('legacyCustomerKeyId'),
      'customerName': sessionStorage.getItem('companyName'),
      'protocol': this.data.pSDtextProtocolDetails
    };

    this.loading = true;
    this.profileService.sendProtocalChangeRequest(data).subscribe(res => {
      this.loading = false;
      if (res.status) {
        this.showToast(this.statusSuccess, this.position, 'Request sent successfully!');
        this.dialogRef.close();
      } else {
        this.showToast(this.statusFailure, this.position, 'Failed to send request. Please try again');
      }

    }, (error) => {
      this.loading = false;
      this.showToast(this.statusFailure, this.position, 'Failed to send request. Please try again');
      console.error('ProtocolChangeRequestDialogComponent_sendChangeRequest', error);
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }

  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: this.destroyByClick,
      duration: this.duration,
      hasIcon: this.hasIcon,
      position: this.position,
      preventDuplicates: this.preventDuplicates,
    };
    const titleContent = body;
    const footer = "";
    this.toastrService.show(
      footer,
      `${titleContent}`,
      config);
  }

}
